import React, { useState } from 'react'
import {
  Typography,
  List,
  ListItem,
  Menu,
  MenuHandler,
  MenuList,
} from '@material-tailwind/react'

// import slugify from '@sindresorhus/slugify'
import { LinkCustom, CardSecondCategory } from './components'
import { DROPMENU_AUTO_WIDTH_COLLECTION } from './const'
import './Navigation.less'
import { lowerCase, toLower } from 'lodash'
import GatsbyMediaByName from '@components/GatsbyMediaByName'

export function Navigation({ className, menus, onNavChange }) {
  const [activeMenu, setActiveMenu] = useState('')

  // 遮罩
  // React.useEffect(() => {
  //   document.body.classList.toggle(
  //     'body-mask',
  //     activeMenu && DROPMENU_FULL_COLLECTION.includes(lowerCase(activeMenu))
  //       ? true
  //       : false,
  //   )
  // }, [activeMenu])

  // 渲染缩略图的辅助函数
  const renderThumbnail = (thumbnailName, title, className = '') => {
    if (!thumbnailName) return null

    // 如果包含 http，使用 img 标签
    if (thumbnailName.includes('http')) {
      return (
        <img
          className={className || 'max-w-full max-h-full'}
          src={thumbnailName}
          alt={title}
        />
      )
    }

    // 否则使用 GatsbyMediaByName
    return (
      <GatsbyMediaByName
        name={thumbnailName}
        className={className || 'max-w-full max-h-full'}
        alt={title}
      />
    )
  }

  const renderMenuItems = (list, prefix = '') => {
    return list.map((item, index) => {
      const { title, link, children, thumbnailName, description } = item
      return (
        <div
          key={`item-${item.title}-${index}`}
          className={`menu-item menu-item-${toLower(
            title.replace(/\s+/g, ''),
          )} flex-shrink-0 flex-grow-0 text-center mr-5 rounded-[4px] overflow-hidden`}
        >
          <LinkCustom
            className={`menu-item-link w-full flex flex-col overflow-hidden text-center `}
            to={link}
            callback={onNavChange}
          >
            {thumbnailName && (
              <div className="menu-item-thumbnail overflow-hidden flex-1 mx-auto">
                {renderThumbnail(thumbnailName, title)}
              </div>
            )}
            <div
              className={`menu-item-title mt-2 text-fluid-xs leading-normal font-medium ${link ? 'cursor-pointer' : 'cursor-auto'}`}
            >
              {title}
            </div>
            {description && (
              <div className="menu-item-description text-fluid-xs text-gray-700 line-clamp-3 leading-normal">
                {description}
              </div>
            )}
          </LinkCustom>
          {/* 如果有子元素，递归调用 */}
          {children && children.length > 0 && (
            <div className="menu-item-children-container transition-all duration-300 ease-in-out text-center">
              {renderMenuItems(children)}
            </div>
          )}
        </div>
      )
    })
  }

  const categoryContainerBuilder = (menu) => {
    const { children, title } = menu
    switch (lowerCase(title)) {
      case 'products':
        return <CardSecondCategory list={children} onNavChange={onNavChange} />
      default:
        return renderMenuItems(children)
    }
  }
  const isActive = (title) => activeMenu === title

  const MainMenuItem = (menu) => {
    const { title } = menu
    const active = isActive(title)
    return (
      <>
        <Menu
          open={active}
          handler={(value) => {
            if (value) {
              setActiveMenu(title)
            } else {
              setActiveMenu('')
            }
          }}
          offset={0}
          placement="bottom"
          // lockScroll={true}
          animate={{
            mount: { y: 0 },
            unmount: { y: -100 },
          }}
          allowHover={true}
        >
          <MenuHandler>
            <Typography as="div">
              <ListItem
                className="nav-item w-auto flex items-center gap-2 py-4 px-6 font-medium text-fluid-sm hover:bg-transparent active:bg-transparent focus:bg-transparent"
                selected={active}
              >
                {menu.link ? (
                  <LinkCustom to={menu.link} callback={onNavChange}>
                    {menu.title}
                  </LinkCustom>
                ) : (
                  menu.title
                )}
              </ListItem>
            </Typography>
          </MenuHandler>
          <MenuList
            className={`nav-container-${lowerCase(
              title,
            )} dropmenu-conainer block py-8 ${
              !DROPMENU_AUTO_WIDTH_COLLECTION.includes(lowerCase(title))
                ? 'w-full border-none shadow-none rounded-none overflow-x-hidden'
                : ''
            } z-[99]`}
          >
            <div
              className={`${
                !DROPMENU_AUTO_WIDTH_COLLECTION.includes(lowerCase(title))
                  ? 'max-w-7xl mx-auto px-4'
                  : ''
              }`}
            >
              <ul className="flex justify-center outline-none outline-0">
                {categoryContainerBuilder(menu)}
              </ul>
            </div>
          </MenuList>
        </Menu>
      </>
    )
  }

  const NavList = () => (
    <List
      className={`nav-container ${
        !!activeMenu ? 'nav-container__open' : ''
      } p-0 flex-row`}
    >
      {menus.map((menu, index) => {
        const { title, link } = menu
        const children = menu.children || []
        const key = `nav-${title}-${index}`
        const hasChildren = !!children.length
        return hasChildren ? (
          <React.Fragment key={key}>{MainMenuItem(menu)}</React.Fragment>
        ) : (
          <ListItem
            key={key}
            className="nav-item w-auto flex items-center gap-2 py-4 px-6 font-medium text-fluid-sm hover:bg-transparent active:bg-transparent focus:bg-transparent"
          >
            <LinkCustom to={link} callback={onNavChange}>
              {title}
            </LinkCustom>
          </ListItem>
        )
      })}
    </List>
  )

  return NavList()
}
